import { DialogContent, Divider } from '@mui/material';
import React from 'react';
import ConfirmDialog from 'shared/components/dialog/ConfirmDialog';
import { Section } from 'shared/components/styled/layouts';
import NotesCreator from './NotesCreator';
import NotesEditor from './NotesEditor';

/**
 * @param {Object} props - The component props
 * @param {Array<Object>} props.initialNotes - Array of Note objects
 * @param {boolean} props.open - Whether the dialog is open
 * @param {*} props.entityType - Entity type
 * @param {number} props.entityID - ID of the entity
 * @param {Function} props.onClose - Callback when dialog closes
 * @param {Function} props.onAddNotes - Handler for adding new notes
 * @param {Function} props.onUpdateNote - Handler for updating a single note
 * @param {Function} props.onDeleteNote - Handler for deleting a single note
 * @param {boolean} props.dirty - Whether there are unsaved changes
 * @param {Function} props.setCreatorDirty - Callback to set creator dirty state
 * @param {Function} props.setEditorDirty - Callback to set editor dirty state
 * @param {string} [props.title='Edit Notes'] - Title for the dialog
 * @param {string} [props.legacyNotes=''] - Legacy notes text
 * @param {Function} [props.onDeleteLegacyNotes] - Handler for deleting legacy notes
 * @returns {JSX.Element}
 */
export default function NotesDialog({
  initialNotes,
  open,
  entityType,
  entityID,
  onClose,
  onAddNotes,
  onUpdateNote,
  onDeleteNote,
  dirty,
  setCreatorDirty,
  setEditorDirty,
  title = 'Edit Notes',
  legacyNotes = '',
  onDeleteLegacyNotes = () => {},
}) {
  return (
    <ConfirmDialog title={title} open={open} onClose={onClose} dirty={dirty}>
      <DialogContent sx={{ padding: 0, background: 'cardBackground' }}>
        <Section>
          <NotesCreator
            onAddNotes={onAddNotes}
            entityType={entityType}
            entityID={entityID}
            setDirty={setCreatorDirty}
          />
        </Section>
        {(initialNotes.length > 0 || legacyNotes) && (
          <>
            <Divider sx={{ marginBottom: '1rem', backgroundColor: 'divider' }} />
            <Section>
              <NotesEditor
                initialNotes={initialNotes}
                open={open}
                onUpdateNote={onUpdateNote}
                onDeleteNote={onDeleteNote}
                setDirty={setEditorDirty}
                legacyNotes={legacyNotes}
                onDeleteLegacyNotes={onDeleteLegacyNotes}
              />
            </Section>
          </>
        )}
      </DialogContent>
    </ConfirmDialog>
  );
}
